<template>
  <section>
    <h1>
      Это страница для входа в аккаунт <strong>юзера</strong>, которая будет в
      будущем.
    </h1>
  </section>
</template>
<script>
export default {
  name: "BaseLoginForUser",
};
</script>
<style lang=""></style>
